exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconfont[data-v-fc79aee8]{color:#ea986c;font-size:.533rem}", ""]);

// exports
